<template>
    <div class="md:px-0">
        <div class="bg-ap-fs-primary py-4 text-2xl text-white px-3 md:px-6">
            Your Booking Summary
        </div>

        <div class="bg-white px-8 py-4 border-b-2 border-gray-300 border-opacity-70">
            <div class="grid grid-cols-2 flex-shrink-0 gap-4">
                <div class="col-span-4 md:col-span-2">
                    <span class="font-bold text-lg">Dates</span>

                    <div class="grid grid-cols-2 gap-6 mt-5">
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Departure Date</p>
                            <span>{{ formatDate(entry) }}</span>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Time</p>
                            <span>{{ formatTime(entry) }}</span>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Return Date</p>
                            <span>{{ formatDate(exit) }}</span>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Time</p>
                            <span>{{ formatTime(exit) }}</span>
                        </div>
                    </div>

                    <div class="mt-5"></div>
                    <hr>
                    <div class="mt-5"></div>
                    <span class="font-bold text-lg">Booking Details</span>

                    <div class="grid grid-cols-2 gap-6 mt-5">
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Vehicle Type</p>
                            <span v-if="vehicleTypeId == 1">Car</span>
                            <span v-if="vehicleTypeId == 2">Van</span>
                            <span v-if="vehicleTypeId == 3">4x4</span>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Registration</p>
                            <span>{{ vehicleRegistration }}</span>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Party Size</p>
                            <span>{{ partySize }}</span>
                        </div>
                        <div class="col-span-1">
                            <p class="text-xs uppercase font-bold">Valet</p>
                            <span>{{ valet?.name ?? 'None' }}</span>
                        </div>
                    </div>

                    <div class="mb-5"></div>
                    <hr>

                    <div v-if="paymentDue > 0" class="my-5 md:col-span-2 text-2xl font-semibold">
                        <p class="text-xs uppercase font-bold">Total</p>
                        <span class="text-3xl text-brand-blue">{{ $filters.money(paymentDue) }}</span>
                    </div>
                    <div v-else class="my-5 md:col-span-2 text-2xl font-semibold">
                        <span class="text-3xl text-brand-blue">No Payment Due</span>
                    </div>

                    <hr v-if="showSaveBtn">

                    <div class="mt-8 px-8 md:px-0" v-if="showSaveBtn">
                        <button :disabled="incomplete"

                            :class="(incomplete) ? 'bg-gray-200 text-gray-400 cursor-default' : 'bg-brand-blue text-white'"
                            class="rounded-lg w-full md:w-auto text-lg px-12 py-2 uppercase  tracking-wider">
                            <span v-if="paymentDue > 0">Go to Payment</span>
                            <span v-else>Update Booking</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import axios from 'axios';

export default {
    methods: {
        calculatePriceChange() {
            // this.saveBtnText = 'Go to Payment';

            axios.post('/account/booking/price/calculate', {
                id: this.booking.id,
                entry: this.entry,
                exit: this.exit,
                vehicle_type_id: this.vehicleTypeId,
            }).then((response) => {
                console.log(response.data);
                this.$emit('priceUpdate', response.data);
            }).catch((err) => {

            });
        },
        formatDate(dt) {
            const date = new Date(dt);
            const months = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ];

            const monthIndex = date.getMonth();
            const monthName = months[monthIndex];

            return `${date.getDate()} ${monthName} ${date.getFullYear()}`;
        },
        formatTime(dt) {
            const date = new Date(dt);

            const hours = (`0${date.getHours()}`).slice(-2);
            const minutes = (`0${date.getMinutes()}`).slice(-2);

            return `${hours}:${minutes}`;
        },
    },
    props: {
        booking: { required: true },
        entry: { required: true },
        exit: { required: true },
        entryDate: { required: true },
        entryTime: { required: true },
        exitDate: { required: true },
        exitTime: { required: true },
        vehicleTypeId: { required: true },
        vehicleRegistration: { required: true },
        partySize: { required: true },
        valet: { required: true },
        fee: { default: 0 },
        showSaveBtn: { default: false },
        paymentDue: { required: false, type: Number },
        product: { required: true },
    },
    watch: {
        entry(value, old) {
            if (old === null) return;

            this.calculatePriceChange();
        },
        exit(value, old) {
            if (old === null) return;

            this.calculatePriceChange();
        },
        vehicleTypeId() {
            this.calculatePriceChange();
        },
    },
};
</script>
